import benefitsJson from "../../data/influencerMarketingBenefits.json";

export default function Section4() {
  const bgImage = {
    backgroundImage: "url('assets/magento-rectangle.png')",
  };

  const benefitsData = benefitsJson;

  return (
    <div
      className="Section4 p-[2%] my-[40px] md:mb-[4%] md:mt-[5%] text-center"
      style={bgImage}
    >
      <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-white my-[0.67em]">
        Why Influencer Marketing
      </h2>

      <div className="w-[90%] flex justify-center gap-x-[1%] gap-y-[19px] md:gap-y-[30px] mx-auto flex-wrap p-[2%_0%_1%_0%]">
        {benefitsData.map(({ imgUrl, title }, index) => {
          return (
            <div
              key={title + index}
              className="bg-white rounded-[10px] text-center p-[10px] w-full xs:w-[45%] md:w-[16%] text-[#373737]"
            >
              <img src={imgUrl} className="mx-auto"></img>

              <h3 className="text-[#2F2F2F] font-bold pb-[4%] my-[0.67em] text-[16px] leading-[26px] capitalize">
                {title}
              </h3>
            </div>
          );
        })}
      </div>
    </div>
  );
}
